import React, { useRef } from 'react'
import styled from 'react-emotion'
import { useTranslation } from 'react-i18next'
import useToggleMenu from '../../../hooks/useToggleMenu'
import { border, rowHeight, z } from '../../../style'
import Button from '../../../../common/components/Button'
import { LabelSet } from '../../../../common/components/Label'
import Icon from '../../../../common/components/Icon'
import Overlay from '../../../../common/components/Overlay'
import Text from '../../../../common/components/Text'
import Row, { RowButton, RowSpacer } from '../../../../common/components/Row'
import {
  BOARDS,
  FOLDERS,
  VIEWED,
  NAME,
  CREATED,
  UNFILED,
  MINE,
  SHARED,
  ARCHIVED,
  FILTERS
} from '../../../constants'

const filters = {
  boards: [
    [
      VIEWED,
      // MODIFIED,
      NAME,
      CREATED
    ],
    [MINE, SHARED, UNFILED, ARCHIVED]
  ],
  folders: [
    [
      // VIEWED,
      // MODIFIED,
      NAME,
      CREATED
    ],
    [MINE, SHARED, ARCHIVED]
  ]
}

const SidebarFilters = ({ section, setSection, filter, setFilter, resetFilter }) => {
  const menuRef = useRef()
  const [menuOpen, showMenu, hideMenu] = useToggleMenu(menuRef)

  const { t } = useTranslation()
  return (
    <>
      <Row>
        <Button
          onClick={showMenu}
          active={menuOpen}
          style={{ zIndex: z.sidebarFilterMenu }}
          tooltip={
            t('sidebar.tooltips.filterShowing') + t(`sidebar.filters.${filter}`)
          }
        >
          {section === BOARDS ? <Icon icon="board" /> : <Icon icon="folder" />}
          <Icon icon="sort" />
        </Button>
        <LabelSet stretch>
          <Button
            selected={section === BOARDS}
            notSelected={section !== BOARDS}
            onClick={() => setSection(BOARDS)}
          >
            <Text medium>{t('sidebar.boards')}</Text>
          </Button>
          <Button
            selected={section === FOLDERS}
            notSelected={section !== FOLDERS}
            onClick={() => setSection(FOLDERS)}
          >
            <Text medium>{t('sidebar.folders')}</Text>
          </Button>
        </LabelSet>
      </Row>

      {menuOpen && (
        <FilterMenu
          section={section}
          currentFilter={filter}
          setFilter={setFilter}
          menuRef={menuRef}
          hide={hideMenu}
        />
      )}

      {FILTERS.includes(filter) && (
        <RowButton selected>
            <Text>
              <Text normal>{t('sidebar.filterShowing')}</Text>{' '}
              {t(`sidebar.filters.${filter}`)}
            </Text>
          <RowSpacer />
          <Button onClick={resetFilter}>
            {t('sidebar.clearFilter')}
          </Button>
        </RowButton>
      )}
    </>
  )
}

const FilterMenu = styled(
  ({ className, section, currentFilter, setFilter, hide, menuRef }) => {
    const { t } = useTranslation()
    return (
      <>
        <Overlay z={z.sidebarFilterMenuOverlay} />
        <div className={className} onClick={hide} ref={menuRef}>
          {filters[section].map((filterset, s) =>
            filterset.map((filter, f) => (
              <RowButton
                bottom={s > 0 && f === 0}
                onClick={() => setFilter(filter)}
                selected={filter === currentFilter}
                notSelected={filter !== currentFilter}
                key={filter}
              >
                  <Icon
                    icon={filter === currentFilter ? 'circle-filled' : 'none'}
                  />
                  <Text medium={filter === currentFilter}>
                    {t(`sidebar.filters.${filter}`)}
                  </Text>
              </RowButton>
            ))
          )}
        </div>
      </>
    )
  }
)({
  background: 'white',
  position: 'absolute',
  left: 0,
  right: 0,
  top: rowHeight.default * 2,
  zIndex: z.sidebarFilterMenu,
  borderBottom: border
})

export default SidebarFilters
